import {
    IonButton,
    IonCard,
    IonContent,
    IonFooter,
    IonInput,
    IonItem,
    IonPage,
    IonText,
    useIonRouter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import React, { FC, useState, useEffect } from "react";
import "../login/login.css";
import "./registerStepThree.css";
import { routes } from "../../route/constants";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { HeaderComponent } from "../../components";
import {
    updateProfile,
    formatProfile,
    getProfile,
} from "../../services/profileService";

/**
 * Team Name
 */
const RegisterStepThree: FC = () => {
    const { t } = useTranslation();
    const profile = useSelector((root: RootState) => root.currentUser?.profile);
    const route = useIonRouter();
    const [teamName, setTeamName] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const userName = profile?.username;

    const [liveProfile, setLiveProfile] = useState<any>();
    useEffect(() => {
        const run = async () => {
            if (!userName) return;
            const profile = await getProfile(userName);
            console.log("Live Profile:", profile);
            setLiveProfile(profile);
        };
        run();
    }, [userName]);

    // Prepopulate team name if it already exists in the profile
    useEffect(() => {
        console.log("Profile:", profile);
        if (liveProfile?.teamName) {
            setTeamName(liveProfile.teamName);
        }
    }, [liveProfile?.teamName]);

    const NEXT_PAGE = routes.registerStepFour;

    const handleNext = async () => {
        if (!liveProfile) return;

        setIsLoading(true);
        try {
            const updatedProfile = {
                ...liveProfile,
                teamName: teamName.trim() || null,
            };

            const formattedProfile = formatProfile(updatedProfile);
            await updateProfile(updatedProfile.username, updatedProfile);
            route.push(NEXT_PAGE, "forward", "replace");
        } catch (error) {
            console.error("Failed to update profile with team name:", error);
            // Continue navigation even if update fails
            route.push(NEXT_PAGE, "forward", "replace");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSkip = async () => {
        if (!profile) return;

        setIsLoading(true);
        try {
            route.push(NEXT_PAGE, "forward", "replace");
        } catch (error) {
            console.error(
                "Failed to update profile with null team name:",
                error
            );
            // Continue navigation even if update fails
            route.push(NEXT_PAGE, "forward", "replace");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <IonPage>
            <HeaderComponent
                title={t("help.OnboardingStepThree.headingTeamInfo")}
                showProgressBar={true}
                progressValue={0.5}
            />

            <IonContent>
                <h2 className="onboarding-section-header">
                    {t("help.OnboardingStepThree.teamName.title")}
                </h2>
                <IonItem lines="none" color="transparent">
                    <IonText className="align-center" style={{ width: "100%" }}>
                        {t("help.OnboardingStepThree.teamName.subtitle")}
                    </IonText>
                </IonItem>

                <IonCard className="question-container">
                    <IonItem lines="none">
                        <IonInput
                            labelPlacement="floating"
                            label="Team Name"
                            value={teamName}
                            placeholder={t(
                                "help.OnboardingStepThree.teamName.placeholder"
                            )}
                            onIonInput={(e) => setTeamName(e.detail.value!)}
                            data-testid="teamNameInput"
                        />
                    </IonItem>
                </IonCard>
            </IonContent>

            <IonFooter>
                <IonButton
                    expand="block"
                    fill="clear"
                    onClick={handleSkip}
                    disabled={isLoading}
                    data-testid="skipButton"
                >
                    {t("general.skip")}
                </IonButton>
                <IonButton
                    expand="block"
                    onClick={handleNext}
                    disabled={isLoading}
                    data-testid="nextButton"
                >
                    {t("general.next")}
                </IonButton>
            </IonFooter>
        </IonPage>
    );
};

export default RegisterStepThree;
